<template>
  <div class="creatCalendar">
    <div class="top-table-btn">
      <el-button type="primary" @click="insertEvent(-1)"
        ><svg-icon
          class="icon-img"
          style="font-size: 16px; padding-right: 6px"
          icon-class="icon-add"
        />{{ $t('currenciesAndCalendar.addCurrencies.add') }}</el-button
      >
      <el-button type="primary" @click="handleDelete('xTable')"
        ><svg-icon
          class="icon-img"
          style="font-size: 16px; padding-right: 6px"
          icon-class="icon-white-delete"
        />{{ $t('currenciesAndCalendar.addCurrencies.deletChange') }}</el-button
      >
    </div>
    <vxe-table
      border
      :auto-resize="true"
      show-overflow
      size="mini"
      ref="xTable"
      :data="personCompanyDos"
      :edit-rules="validRules"
      :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
    >
      <vxe-table-column type="checkbox" width="80"></vxe-table-column>
      <vxe-table-column
        type="index"
        :title="$t('currenciesAndCalendar.queryCurrencies.index')"
        width="80"
      ></vxe-table-column>
      <vxe-table-column
        field="calendarCode"
        :title="$t('currenciesAndCalendar.searchCalendar.calendarCode')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-input
            v-model="scope.row.calendarCode"
            @input="$refs.xTable.updateStatus(scope)"
            clearable
          ></el-input>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="calendarType"
        :title="$t('currenciesAndCalendar.searchCalendar.calendarType')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-select v-model="scope.row.calendarType" filterable clearable>
            <el-option
              v-for="item in sequenceOrderList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          getSelectLabel(row.calendarType, sequenceOrderList)
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="calendarDesc"
        :title="$t('currenciesAndCalendar.searchCalendar.calendarDesc')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-input
            v-model="scope.row.calendarDesc"
            maxlength="60"
            @input="$refs.xTable.updateStatus(scope)"
            clearable
          ></el-input>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="initOpenYear"
        :title="$t('currenciesAndCalendar.searchCalendar.currentOpenYear')"
        min-width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-select v-model="scope.row.initOpenYear" filterable clearable>
            <el-option
              v-for="item in yearList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{ getSelectLabel(row.initOpenYear, yearList) }}</template>
      </vxe-table-column>
    </vxe-table>
    <div class="fixed-bottom-btnList">
      <el-button type="primary" class="fixed-bottom-btn" icon="el-icon-edit" @click="goBack">{{
        $t('currenciesAndCalendar.addCurrencies.goBack')
      }}</el-button>
      <el-button
        type="primary"
        class="fixed-bottom-btn"
        icon="el-icon-edit"
        @click="saveCurrencies"
        >{{ $t('currenciesAndCalendar.addCurrencies.sure') }}</el-button
      >
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/financeCenter/searchCalendar';
  import XEUtils from 'xe-utils';
  export default {
    name: 'creatCalendar',
    data() {
      //校验日历代码
      var checkCalendarCode = (rule, value, callback) => {
        let reg = /^[A-Z]+$/;
        let reg2 = /^[A-Z]{0,10}$/;
        if (!reg.test(value)) {
          callback(new Error(this.$t('currenciesAndCalendar.rules.writeCapital')));
        }
        if (!reg2.test(value)) {
          callback(new Error(this.$t('currenciesAndCalendar.rules.writeLength')));
        } else {
          callback();
        }
      };
      return {
        validRules: {
          calendarCode: [
            {
              required: true,
              message: this.$t('currenciesAndCalendar.searchCalendar.writeCalendarCode'),
            },
            { validator: checkCalendarCode },
          ],
          calendarType: [
            {
              required: true,
              message: this.$t('currenciesAndCalendar.searchCalendar.writeCalendarType'),
            },
          ],
          calendarDesc: [
            {
              required: true,
              message: this.$t('currenciesAndCalendar.searchCalendar.writeCalendarDesc'),
            },
          ],
          initOpenYear: [
            {
              required: true,
              message: this.$t('currenciesAndCalendar.searchCalendar.changeCurrentOpenYear'),
            },
          ],
        },
        flag: true,
        personCompanyDos: [],
        sequenceOrderList: [],
        yearList: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      user() {
        return this.userInfo.userInfo;
      },
    },
    mounted() {
      this.getNationality();
      this.getYearList();
    },
    methods: {
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      //增加
      insertEvent(row) {
        let xTable = this.$refs.xTable;
        let record = {};
        xTable.insertAt(record, row).then(({ row }) => {
          let date = new Date();
          row.initOpenYear = date.getFullYear();
          xTable.setActiveRow(row);
        });
        this.personCompanyDos = this.$refs.xTable.getTableData().fullData;
      },
      // 删除
      handleDelete(tableTpye) {
        const selectedList = this.$refs[tableTpye].getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('personnel.table.chockedLows'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs[tableTpye].removeSelecteds();
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('personnel.table.deletSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('personnel.table.deletFalse'),
            });
          });
      },
      //保存
      saveCurrencies() {
        //    this.save(this.personCompanyDos)
        this.flag = true;
        let formList = ['xTable'];
        let resultArr = [];
        let _self = this;
        function validates(formName) {
          let result = new Promise((resolve, reject) => {
            // _self.$refs[formName].validate(valid => {
            //   valid ? resolve() : reject();
            // });
            _self.$refs[formName]
              .validate()
              .then(() => {
                resolve();
              })
              .catch(() => {
                reject();
              });
          });
          resultArr.push(result);
        }
        formList.forEach((item) => {
          validates(item); // 循环校验
        });
        this.personCompanyDos = this.$refs.xTable.getTableData().fullData;
        if (this.personCompanyDos.length <= 0) {
          this.flag = false;
        }
        console.log(resultArr);
        return Promise.all(resultArr)
          .then(() => {
            if (!this.flag) {
              this.$message({
                showClose: true,
                message: this.$t('personnel.table.tableTitle'),
                type: 'error',
              });
            } else {
              this.save(this.personCompanyDos);
            }
          })
          .catch(() => {});
      },
      save(val) {
        let query = [];
        val.forEach((item) => {
          let obj = Object.assign({}, item, this.userInfo.userInfo);
          query.push(obj);
        });
        this.$axios.post(API.ADD_ACCOUNT_CALENDARS, query).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            this.goBack();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //取消
      goBack() {
        let pathList = {
          fromPath: {
            path: '/generalAccounting/creatCalendar',
            name: 'creatCalendar',
            meta: {
              keepAlive: true,
              title: this.$t('currenciesAndCalendar.searchCalendar.calendarAdd'),
            },
          },
          toPath: {
            path: '/generalAccounting/searchCalendar',
            name: 'searchCalendar',
            meta: {
              keepAlive: false,
              title: this.$t('currenciesAndCalendar.creatCalendar.viewCalendar'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', pathList).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathList.toPath);
          });
        });
      },
      //获取当前年度
      getYearList() {
        let date = new Date();
        let year = date.getFullYear();
        year = year - 11;
        for (let i = 0; i < 21; i++) {
          year = year + 1;
          let object = { value: year, label: year };
          this.yearList.push(object);
        }
      },
      //获取日历类型
      async getNationality() {
        let params = {
          dictType: 'calendar_type',
        };
        const selectStatus = await this.$axios.post(API.LISTDATA_DICTBYDATACODE, params);
        if (selectStatus.data.code == 0) {
          this.sequenceOrderList = selectStatus.data.data;
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .creatCalendar .creatButton {
    background-color: rgb(98, 153, 254) !important;
    border: 1px solid rgb(98, 153, 254) !important;
    min-width: 80px;
    border-radius: 2px !important;
    margin-bottom: 10px;
  }
  .creatCalendar .deteButton {
    background-color: #fe8783 !important;
    border: 1px solid #fe8783 !important;
    min-width: 80px;
    border-radius: 2px !important;
    margin-bottom: 10px;
  }
</style>
